import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const LeagueAnalysisCard = ({ league }) => {
  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden hover:shadow-lg transition-shadow duration-300">
      <div className="relative h-32 md:h-40 overflow-hidden">
        <Image
          src={league?.image}
          alt={league?.imageAlt}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background/90 to-transparent" />
        <div className="absolute bottom-3 left-3 right-3">
          <h3 className="text-base md:text-lg font-bold text-white mb-1">{league?.name}</h3>
          <p className="text-xs text-white/80">{league?.country}</p>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <div className="grid grid-cols-2 gap-3 md:gap-4 mb-4">
          <div>
            <p className="text-xs text-muted-foreground mb-1">Active Transfers</p>
            <p className="text-lg md:text-xl font-bold text-foreground">{league?.activeTransfers}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1">Total Value</p>
            <p className="text-lg md:text-xl font-bold text-foreground">{league?.totalValue}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1">Avg. Age</p>
            <p className="text-lg md:text-xl font-bold text-foreground">{league?.avgAge}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1">Growth</p>
            <div className="flex items-center gap-1">
              <Icon name="TrendingUp" size={16} color="var(--color-success)" />
              <p className="text-lg md:text-xl font-bold text-success">{league?.growth}</p>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="BarChart3" size={16} color="var(--color-primary)" />
          <p className="text-xs md:text-sm text-muted-foreground">{league?.insight}</p>
        </div>
      </div>
    </div>
  );
};

export default LeagueAnalysisCard;